module.exports = __webpack_public_path__ + "img/interstitial_2.513c5541.jpg";